import SkapaInlineMessage from '../../../ui/InlineMessage/SkapaInlineMessage';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getProductsForGroup } from '../../../ducks/products';
import { ProductType } from '@inter-ikea-storageone/range';
import { getFilterOptions, getUnit } from '../../../filters/SizeFilter/utils';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import Box from '../../../ui/Box';
import media from '../../../ui/media';

const Wrapper = styled(Box)`
  ${media.mobile`
  padding: 0.5rem 0.75rem 0.75rem 0.75rem;
`};
`;

const CabinetDescription = () => {
  const { formatMessage } = useIntl();

  const products = useSelector(getProductsForGroup);
  const cabinets = products.filter(product =>
    [ProductType.BROR_CABINET_BLACK, ProductType.BROR_CABINET_GREEN].includes(product.type)
  );
  const cabinetsDepth = getFilterOptions('depth')(cabinets);
  const unit = getUnit(cabinets);
  const depth = Object.entries(cabinetsDepth).map(([, depth]) => ({
    depth
  }));
  const depthValue = depth[0].depth;
  const infoMessage = {
    params: { depth: depthValue, unit }
  };
  return (
    <Wrapper>
      <SkapaInlineMessage
        title={formatMessage({ id: 'storageone.placementOfCabinet' })}
        body={formatMessage({ id: 'storageone.placementOfCabinetDetails' }, infoMessage.params)}
        subtle={false}
        ssrIcon={InformationCircle}
      />
    </Wrapper>
  );
};

export default CabinetDescription;
